import { render, staticRenderFns } from "./DashboardAdoption.vue?vue&type=template&id=66bf3555"
import script from "./DashboardAdoption.vue?vue&type=script&lang=js"
export * from "./DashboardAdoption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports